import React from 'react';
import SimplePage from '../../../../../component/common/landing-page/SimpleLandingPage';

export default function SimpleLandingPage() {
    return (
        <>
            <SimplePage/>
        </>
    )
}
